<template>
    <div class="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
        <!-- <div class="sm:mx-auto sm:w-full sm:max-w-sm">
            <img class="mx-auto h-10 w-auto" src="../../assets/img/logo.svg"
                alt="Your Company" />
            <h2 class="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">Register</h2>
        </div> -->
        <h1
            class="relative mb-4 text-3xl font-black leading-tight text-gray-900 lg:text-center md:text-center sm:text-center sm:text-6xl xl:mb-8">
            Register</h1>
        <p class="text-base  text-gray-600 lg:text-center sm:text-center sm:text-lg xl:text-xl normal-case">To get the
            special offers and discounts</p>

        <div class="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
            <form class="space-y-6" @submit.prevent="Register">
                <div v-if="error" class="bg-red-500 text-white font-bold py-2 px-4 rounded">{{ error }}
                </div>
                <div>
                    <label for="name" class="block text-sm font-medium leading-6 text-gray-900">Name</label>
                    <div class="mt-2">
                        <input id="name" v-model="name" type="text" required autofocus
                            class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-orange-600 sm:text-sm sm:leading-6" />
                    </div>
                </div>

                <div>
                    <label for="email" class="block text-sm font-medium leading-6 text-gray-900">Email
                        address</label>
                    <div class="mt-2">
                        <input id="email" v-model="email" type="email" required
                            class="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-orange-600 sm:text-sm sm:leading-6" />
                    </div>
                </div>

                <div>
                    <label for="password" class="block text-sm font-medium leading-6 text-gray-900">Password</label>
                    <div class="mt-2">
                        <input id="password" v-model="password" type="password" required
                            class="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-orange-600 sm:text-sm sm:leading-6" />
                    </div>
                </div>

                <div>
                    <button type="submit"
                        class="flex w-full justify-center rounded-md bg-orange-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-orange-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-600">Register</button>
                </div>
            </form>

            <p class="mt-10 text-center text-sm text-gray-500">
                Already a registered?
                {{ ' ' }}
                <router-link to="/login" class="font-semibold leading-6 text-orange-600 hover:text-orange-500">Log
                    in</router-link>
            </p>
        </div>
    </div>
</template>

<script>
import { ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

// import jsPDF from 'jspdf';

export default {
    name: "RegisterComponent",
    setup() {
        const name = ref('')
        const email = ref('')
        const password = ref('')
        const error = ref(null)

        const store = useStore()
        const router = useRouter()

        const Register = async () => {

            try {
                await store.dispatch('register', {
                    email: email.value,
                    password: password.value,
                    name: name.value
                })
                router.push('/');
            }
            catch (err) {
                error.value = err.message
            }
        }

        return { Register, name, email, password, error }
    },
    // methods: {
    //     onSubmit() {
    //         // Call your functions here
    //         this.createPDF();
    //         this.Register();
    //     },
    //     createPDF() {
    //         let pdfName = 'Voucher'
    //         var doc = new jsPDF('p', 'mm', [210, 99]) // A4/3 size page in portrait orientation

    //         // Set font size
    //         doc.setFontSize(22);

    //         // Set text color to orange
    //         doc.setTextColor(255, 165, 0);

    //         // Add title
    //         doc.text("Pet Kingdom Voucher", 10, 30);

    //         // Set font size for body
    //         doc.setFontSize(16);

    //         // Set text color to black
    //         doc.setTextColor(0, 0, 0);

    //         // Add body text
    //         doc.text("-40% Your Next Purchase", 10, 60);
    //         doc.text("COUPON CODE: 1234-5678", 10, 80);
    //         doc.text("VALID UNTIL 31.12.2024", 10, 100);

    //         // Save the PDF
    //         doc.save(pdfName + '.pdf');
    //     }
    // }
};
</script>